<template functional>
  <div class="flex flex-col gap-0.5">
    <div class="flex items-center justify-center gap-1">
      <check-marker
        :size="16"
        :item="{
          id: props.item.id,
          marker: props.item.marker,
          target: 'order',
        }"
      />
      <note-entry
        :size="16"
        :options="{
          name: props.item.container_no,
          id: props.item.id,
          type: 'Container',
          category: 'admin',
          noted: props.item.admin_noted,
        }"
      />
      <container-colorify
        :size="16"
        :item="{ id: props.item.id, color: props.item.color }"
      />
    </div>
    <div class="flex items-center justify-center gap-1">
      <slot v-if="props.item.brokered">
        <broker-orders :id="props.item.id" :size="16" placement="bottom" />
      </slot>
    </div>
    <div class="flex flex-col gap-0.5">
      <div class="public-lfd" v-if="props.item.public_alerts.includes('lfd')">
        Public LFD
      </div>
      <div
        class="public-po"
        v-if="props.item.public_alerts.includes('pickup_no')"
      >
        Public PO#
      </div>
      <div class="public-erd" v-if="props.item.public_alerts.includes('erd')">
        Public ERD
      </div>
      <div class="public-cod" v-if="props.item.public_alerts.includes('cod')">
        Public COD
      </div>
      <div class="claimed" v-if="props.item.claimed">Claimed</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-action",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style lang="scss" scoped>
.public-lfd {
  @apply bg-red-400 text-3xs font-bold text-white px-1 rounded;
}
.public-po {
  @apply bg-orange-400 text-3xs font-bold text-white px-1 rounded;
}
.public-erd {
  @apply bg-red-400 text-3xs font-bold text-white px-1 rounded;
}
.public-cod {
  @apply bg-orange-400 text-3xs font-bold text-white px-1 rounded;
}
.claimed {
  @apply bg-green-600 text-3xs font-bold text-white px-1 rounded;
}
</style>
